import{b as e}from"./chunk-TN4M2PHH.mjs";import{h as o,i as r}from"./chunk-2JBE4HP3.mjs";var f=new o({locale:[e,r]});export{f as a};
